import APIController from 'api/core-api-controller';

export const fetchCurrentTenantApi = () => {
  const path = `${APIController.endpointApi}/current_tenant`;
  return APIController.getApiCallback(path);
};
